export default function Bonuses() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="bonos" className="relative bg-[#0a0a0a] py-20 md:py-28 px-6 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF6B35] via-[#FF3D00] to-[#FF6B35]"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF6B35] via-[#FF3D00] to-[#FF6B35]"></div>

      <div className="relative max-w-5xl mx-auto">
        {/* Header banner */}
        <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF3D00] rounded-2xl p-5 md:p-8 text-center mb-12 md:mb-16">
          <p className="text-black font-black text-xl sm:text-2xl md:text-4xl leading-tight">
            ⚠️ ATENCIÓN: BONOS EXCLUSIVOS SOLO POR HOY
          </p>
          <p className="text-black/80 mt-2 text-sm sm:text-base font-semibold">
            Si tomas acción HOY, te llevas 2 PDFs de mi arsenal privado
          </p>
        </div>

        {/* Bonus cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {[
            {
              label: 'Bono 1',
              title: '"Mentalidad de Estratega"',
              desc: 'Piensa como dueño de negocio, no como autoempleado. El PDF que cambia cómo ves cada decisión financiera.',
            },
            {
              label: 'Bono 2',
              title: '"Sella tu Embudo Financiero"',
              desc: 'Identifica gastos vampiro y redirige ese dinero a campañas de tráfico. Tu rentabilidad al siguiente nivel.',
            },
          ].map((bonus, i) => (
            <div
              key={i}
              className="relative bg-[#111] rounded-2xl p-8 border border-white/10 hover:scale-[1.02] transition-all duration-300"
            >
              <span className="absolute top-4 right-4 text-xs font-bold px-3 py-1 rounded-full bg-[#FF6B35]/20 text-[#FF6B35]">
                PDF Exclusivo
              </span>
              <div className="text-5xl mb-5">🎁</div>
              <p className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest mb-2">{bonus.label}</p>
              <h3 className="text-white text-xl md:text-2xl font-black mb-4">{bonus.title}</h3>
              <div className="w-12 h-0.5 bg-[#FF6B35]/40 rounded-full mb-4"></div>
              <p className="text-gray-400 text-sm leading-relaxed">{bonus.desc}</p>
            </div>
          ))}
        </div>

        {/* Price summary */}
        <div className="bg-[#111] border border-white/10 rounded-2xl p-8 text-center mb-12">
          <p className="text-gray-400 text-sm mb-3">Valor total del pack</p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-3">
            <div className="text-center">
              <p className="text-gray-500 text-xs uppercase tracking-wider">Stock Simple</p>
              <p className="text-white text-xl md:text-2xl font-black line-through opacity-50">$30</p>
            </div>
            <div className="text-[#00FF88] text-2xl md:text-3xl font-black">+</div>
            <div className="text-center">
              <p className="text-gray-500 text-xs uppercase tracking-wider">Budgettrack</p>
              <p className="text-white text-xl md:text-2xl font-black line-through opacity-50">$30</p>
            </div>
            <div className="text-[#FF6B35] text-2xl md:text-3xl font-black">+</div>
            <div className="text-center">
              <p className="text-gray-500 text-xs uppercase tracking-wider">2 PDFs Bonos</p>
              <p className="text-white text-xl md:text-2xl font-black line-through opacity-50">$20</p>
            </div>
            <div className="text-white text-2xl md:text-3xl font-black">=</div>
            <div className="text-center">
              <p className="text-[#00FF88] text-xs uppercase tracking-wider font-bold">HOY PAGAS</p>
              <p className="text-[#00FF88] text-3xl md:text-4xl font-black">$12</p>
              <p className="text-gray-500 text-xs">/año</p>
            </div>
          </div>
        </div>

        {/* CTA button */}
        <div className="text-center">
          <a
            href="https://pay.hotmart.com/H105250353B?checkoutMode=10"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-[#FF6B35] via-[#FF5520] to-[#FF3D00] text-white font-black text-lg md:text-xl px-10 py-6 rounded-2xl hover:scale-105 transition-all duration-300 cursor-pointer text-center w-full sm:w-auto whitespace-nowrap"
          >
            <span className="flex-shrink-0">🔥</span>
            <span className="leading-snug">
              QUIERO EL PACK + LOS BONOS<br className="block" />
              ($12/AÑO)
            </span>
          </a>
          <p className="text-gray-500 text-xs mt-4">
            Acceso inmediato tras el pago · Garantía de satisfacción · 100% seguro
          </p>
        </div>
      </div>
    </section>
  );
}
